import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

/* global logoSliderOptions */
// The array coming from localize script in functions.php

// activate doctor logos row swiper slider
const doctorLogosSwiper = new Swiper(".doctors-logos", {
  modules: [Autoplay],
  // Optional parameters
  slidesPerView: 5,
  spaceBetween: 15,
  loop: true,
  speed: 4000,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.5,
      spaceBetween: 20,
      centeredSlides: true,
    },
    480: {
      slidesPerView: 2.5,
      spaceBetween: 30,
      centeredSlides: true,
    },
    640: {
      slidesPerView: 3,
    },
    1025: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1400: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
  },
});

const testimonialSlider = document.querySelector(".front-testimonials__swiper");
if (testimonialSlider) {
  const testimonialSliderSwiper = new Swiper(".front-testimonials__swiper", {
    modules: [Navigation, Autoplay],
    navigation: {
      nextEl: ".front-testimonials__swiper-button-next",
      prevEl: ".front-testimonials__swiper-button-prev",
    },
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 7000,
    },
  });
}

/**
 * Procedures Slider
 */

const proceduresSlider = document.querySelector(
  ".front-procedures-slider .swiper-container"
);

if (proceduresSlider) {
  // for procedure slider we need custom pagination, so we create
  // array of names for it
  let labels = [];

  document
    .querySelectorAll(".front-procedures-slider .swiper-slide")
    .forEach((slide) => {
      labels.push(slide.dataset.title);
    });

  new Swiper(proceduresSlider, {
    modules: [Pagination, EffectFade],
    slidesPerView: 1,
    spaceBetween: 250,
    centeredSlides: true,
    autoHeight: true,
    effect: "fade",
    speed: 500,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: true,
    // If we need pagination
    pagination: {
      el: ".front-procedures-slider__pagination",
      clickable: true,
      renderBullet: function (index, className) {
        const label = labels[index];
        return (
          '<div class="' +
          className +
          '"><div class="inner">' +
          label +
          "</div></div>"
        );
      },
    },
  });
}
